import { render, staticRenderFns } from "./WriterView.vue?vue&type=template&id=0cc0f873&"
import script from "./WriterView.vue?vue&type=script&lang=js&"
export * from "./WriterView.vue?vue&type=script&lang=js&"
import style0 from "./WriterView.vue?vue&type=style&index=0&id=0cc0f873&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports